/**
 * Constants for the recruiting supporters application
 */

export const JOB_TYPE_OPTIONS = [
  { code: 1, text: 'エンジニア' },
  { code: 2, text: 'マーケティング' },
  { code: 3, text: '営業' },
  { code: 4, text: '人事' },
  { code: 5, text: '経理' },
  { code: 6, text: 'デザイナー' },
  { code: 7, text: 'プロダクトマネージャー' },
  { code: 9, text: 'その他' }
];

export const getJobTypeString = (code: number): string => {
  const option = JOB_TYPE_OPTIONS.find(option => option.code === code);
  return option ? option.text : '';
};

export const POSITION_OPTIONS = [
  { code: 1, text: '社長' },
  { code: 2, text: '役員' },
  { code: 3, text: '部長' },
  { code: 4, text: '課長' },
  { code: 5, text: '主任' },
  { code: 6, text: '一般社員' },
  { code: 9, text: 'その他' }
];

export const getPositionString = (code: number): string => {
  const option = POSITION_OPTIONS.find(option => option.code === code);
  return option ? option.text : '';
};

export const STATUS = {
  PENDING: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2
} as const;

export type StatusType = typeof STATUS[keyof typeof STATUS];

export const STATUS_TEXT: Record<StatusType, string> = {
  [STATUS.PENDING]: '未案内',
  [STATUS.IN_PROGRESS]: '進行中',
  [STATUS.COMPLETED]: '完了'
};

export const STATUS_CLASS: Record<StatusType, string> = {
  [STATUS.PENDING]: 'status-pending',
  [STATUS.IN_PROGRESS]: 'status-in-progress',
  [STATUS.COMPLETED]: 'status-completed'
};

export const PAGINATION = {
  ITEMS_PER_PAGE: 10
} as const;

export const RESPONDENT_FORM_STEP = {
  INPUT: 1,
  CONFIRM: 2,
  COMPLETED: 3
} as const;

export const RESPONSE_FORM_STEP = {
  RELATIONSHIP: 1,
  QUESTIONS: 2,
  SOCIAL_SKILL: 3,
  SURVEY: 4,
  CONFIRM: 5,
} as const;

export const RELATIONSHIP_OPTIONS = [
  { code: 1, text: '上司' },
  { code: 2, text: '先輩' },
  { code: 3, text: '同僚' },
  { code: 4, text: '部下' },
  { code: 5, text: '後輩' },
  { code: 9, text: 'その他' }
];

export const getRelationshipString = (code: number): string => {
  const option = RELATIONSHIP_OPTIONS.find(option => option.code === code);
  return option ? option.text : '';
};

export const PERIOD_OPTIONS = [
  { code: 1, text: '春頃（4~6月）' },
  { code: 2, text: '夏頃（7~9月）' },
  { code: 3, text: '秋頃（10~12月）' },
  { code: 4, text: '冬頃（1~3月）' }
];

export const getPeriodString = (code: number): string => {
  const option = PERIOD_OPTIONS.find(option => option.code === code);
  return option ? option.text : '';
};

export const ACTIVITY_FREQUENCY_OPTIONS = [
  { code: 1, text: '週に1~3日以上' },
  { code: 4, text: '週に4~5日以上' },
  { code: 6, text: '週に6日以上' }
];

export const getActivityFrequencyString = (code: number): string => {
  const option = ACTIVITY_FREQUENCY_OPTIONS.find(option => option.code === code);
  return option ? option.text : '';
};

export const PASSWORD_VALIDATION = {
  MIN_LENGTH: 12,
  SYMBOLS: '!@#$%^&*()_+-=[]{}|;:,.<>?',
  LETTERS_PATTERN: '[a-zA-Z]',
  DIGITS_PATTERN: '[0-9]',
  ERROR_MESSAGE: 'パスワードは12文字以上で、英字、数字、記号を全て含めて入力してください。',
  SHORT_COMMENT: '12文字以上の英字、数字、記号'
} as const;
